export const CUSTOMER_SHOW_TABS = [
  'general',
  'entitlements',
  'billing_periods',
  'events',
  'withdrawal_contracts',
] as const;

export type CustomerShowTab = (typeof CUSTOMER_SHOW_TABS)[number];

export const CUSTOMER_DEFAULT_TAB: CustomerShowTab = 'general';
